import { useEffect } from 'react';
import type { Scenario } from '../types';
import { collectGameplayPrefetchUrls, prefetchAssetUrls } from './scenario-assets';

/** Prefetch upcoming chapter / mission assets while the player is in a scene. */
export function useAssetPrefetch(
  scenario: Scenario | null | undefined,
  currentSceneId: string | undefined,
): void {
  useEffect(() => {
    if (!scenario || !currentSceneId) return;
    const timerId = window.setTimeout(() => {
      prefetchAssetUrls(collectGameplayPrefetchUrls(scenario, currentSceneId));
    }, 0);
    return () => window.clearTimeout(timerId);
  }, [scenario, currentSceneId]);
}
